<template>
    <div class="automation-block-editor loop">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.loopLoopType') }}</div>
            <CustomPicker v-model="clone.mode" :items="loopType" idKey="id" labelKey="label" title="Select Loop Type" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">{{ $t('auto.loopTrimWhitespace') }}</div>
            <a-switch v-model="clone.options.trimWhitespace" />
        </div>
        <div class="editor-row customize-editor-minimize" key="clone.options.iterationCounterStart">
            <div class="editor-row-title">{{ $t('auto.loopLoopIterationCounterStart') }}</div>
            <TiptapEditor
                placeholder="Loop Iteration Counter Start"
                :show-attributes="true"
                v-model="clone.options.iterationCounterStart"
                automation-mode
                :show-emoji="false"
            />
            <small class="description">
                {{ $t('auto.loopACounterValueCalledLoopIterationWillBeAddedToEachIterationOfTheLoopDoesNotAffectTheDataToLoopThroughDefaultsTo0') }}
            </small>
        </div>
        <div class="editor-row customize-editor-minimize" key="clone.options.maximumIterations">
            <div class="editor-row-title">{{ $t('auto.loopMaxNumberOfLoopIteration') }}</div>
            <TiptapEditor
                placeholder="Max Number of Loop Iteration"
                :show-attributes="true"
                v-model="clone.options.maximumIterations"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">
                {{ $t('auto.loopSetThisValueToLimitTheNumberOfLoopsPerformedDataInIterationsPastTheLimitWillBeIgnoredANumberHigherThan500WillBeReducedTo500ANumberLessThan1WillHaltThisStep') }}
            </small>
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'numbers'" key="clone.number.end">
            <div class="editor-row-title">{{ $t('auto.loopLoopIterationCounterEnd') }}</div>
            <TiptapEditor
                placeholder="Loop Iteration Counter End"
                :show-attributes="true"
                v-model="clone.number.end"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">
                {{ $t('auto.loopSetTheIterationNumberToEndTheLoopAtHereDefaultsTo1CannotBeLessThanLoopIterationCounterStart') }}
            </small>
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'numbers'" key="clone.number.increment">
            <div class="editor-row-title">{{ $t('auto.loopLoopIterationCounterIncrementAmount') }}</div>
            <TiptapEditor
                placeholder="Loop iteration counter increment amount"
                :show-attributes="true"
                v-model="clone.number.increment"
                :show-emoji="false"
                automation-mode
            />
            <small class="description">
                {{ $t('auto.loopSetTheAmountToIncrementTheCounterForEachIterationOfTheLoopDefaultsTo1CannotBe0OrNegativeMustBeAnWholeNumber') }}
            </small>
        </div>

        <div class="editor-row customize-editor-minimize data-items" v-if="clone.mode === 'line-items'">
            <div class="editor-row-title">{{ $t('auto.loopLineItemSToLoop') }}</div>
            <DataItem
                v-for="(item, index) in clone.items || []"
                v-model="clone.items[index]"
                :key="index"
                @delete="() => clone.items.splice(index, 1)"
            />
            <SupsisButton small ghost @click="addItem"> {{ $t('auto.loopAddItem') }}</SupsisButton>
        </div>
        <div class="editor-row customize-editor-minimize data-items" v-if="clone.mode === 'text'">
            <div class="editor-row-title">{{ $t('auto.loopTextToLoop') }}</div>
            <DataItem
                v-for="(item, index) in clone.items || []"
                v-model="clone.items[index]"
                :key="index"
                @delete="() => clone.items.splice(index, 1)"
            />
            <SupsisButton small ghost @click="addItem" v-if="(clone.items || []).length < 1"> {{ $t('auto.loopAddItem') }}</SupsisButton>
        </div>
        <div class="editor-row customize-editor-minimize" v-if="clone.mode === 'text'" key="clone.text.delimiter">
            <div class="editor-row-title">{{ $t('auto.loopTextDelimiter') }}</div>
            <TiptapEditor
                placeholder="Text Delimiter"
                :show-attributes="true"
                v-model="clone.text.delimiter"
                :show-emoji="false"
                automation-mode
            />
            <small class="description"> {{ $t('auto.loopSupportsSpecialCharactersDefaultsTo') }} </small>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import CustomPicker from "../../../../../../../components/pickers/CustomPicker.vue";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";
import DataItem from "../webhook/DataItem.vue";

const log = log2("Loop");
export default {
    name: "Loop",
    components: { DataItem, SupsisButton, CustomPicker, TiptapEditor },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "line-items", //line-items,numbers,text
            options: {
                iterationCounterStart: 0,
                maximumIterations: 500,
                trimWhitespace: true,
            },
            number: {
                start: 0,
                end: 10,
                increment: 1,
            },
            items: [],
            text: {
                delimiter: ",",
            },
        };
        return {
            clone,
            loopType: [
                { id: "line-items", label: "Line Items", description: "Create loop from line Item(s)" },
                { id: "numbers", label: "Numbers", description: "Create loop from number range" },
                { id: "text", label: "Text", description: "Create loop from text" },
            ],
        };
    },
    methods: {
        addItem() {
            this.clone.items.push({ key: null, value: null });
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.loop {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        small.description {
            font-size: 10px;
            color: var(--color-text-weak-default);
        }

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
